export enum CompanyServiceActionType {
  OnChangingSelectedCompany = 'OnChangingSelectedCompany'
}

export enum BudgetServiceActionType {
  OnChangingSelectedBudget = 'OnChangingSelectedBudget'
}